import { Chip, SwitchButton } from "@ui";
import style from "./SellingCell.module.scss";
import cn from "classnames";
import { IProxy } from "@interfaces/admin/proxy";
import { addRowError, removeRowError } from "@global-state/pages/admin/myProxies/slice";
import { useUpdateProxyDataMutation } from "@RTKQuery/admin/proxy/proxy";
import { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "store/hooks";
import { IoClose } from "react-icons/io5";

export function SellingCell({ selling, proxy }: { selling: IProxy["selling"], proxy: IProxy | IProxy["children"][0] }) {
    const [updateProxyData, { isError, isSuccess, reset }] = useUpdateProxyDataMutation();

    const {activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling} = useAppSelector(state => state.myProxiesAdminPage);
    const rowsIsError = useAppSelector(state => state.myProxiesAdminPage.rowsIsError)?.[proxy.id] || [];

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isSuccess) {
            dispatch(removeRowError({
                proxyId: proxy.id, 
                colName: "selling"
            }))
        }
    }, [isSuccess])

    return (
        <div className={cn(style.cell, "w-[60px] flex items-center justify-center")} >
            <SwitchButton
                checked={selling}
                onChecked={() => {
                    updateProxyData({
                        proxy_id: proxy.id,
                        parent_id: proxy.parent_id || undefined,
                        params: {
                            page: activePaginationPage,
                            limit: activePaginationLimit,
                            router_id: activeSearchIdParameter,
                            operator: activeOperator,
                            phone_number: activeSearchPhoneParameter,
                            selling: activeSelling
                        },
                        body: {
                            selling: !selling
                        }
                    })
                }}
            />

            <div className={cn("absolute left-full top-1/2 z-10 pl-[5px] -translate-y-1/2", rowsIsError.includes("selling") ? "block" : "hidden")}>
                <Chip
                    text="Помилка"
                    color="red"
                    icon={<IoClose
                        className="w-[15px] text-[#F81F1F] h-[15px] cursor-pointer"
                        onClick={() => {
                            reset();
                            dispatch(removeRowError({
                                proxyId: proxy.id, 
                                colName: "selling"
                            }))
                        }}
                    />}
                    aligtIcon="right"
                />
            </div>
        </div>
    )
}